import React from 'react';

interface StructuredDataProps {
  type: 'Person' | 'WebSite' | 'Organization' | 'Article' | 'BreadcrumbList';
  data: Record<string, any>;
}

/**
 * Componente para añadir datos estructurados JSON-LD a las páginas
 * @param {StructuredDataProps} props - Propiedades del componente
 */
const StructuredData: React.FC<StructuredDataProps> = ({ type, data }) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default StructuredData;
